import { b as B, d as J } from "./index-E8vB_04G.js";
import { l as w } from "./index-b-LDu0Rp.js";
import { n as O } from "./nacl-fast-DmSj04OB.js";
import { data_room as b, ZodError as F } from "ddc";
import { C as M, d as V, e as z, A as W, E as l, h as E, g as u, i as G, S as K, t as Q, c as Y } from "./utils-dinPOBnH.js";
import { generateKey as Z, generateSelfSignedCertificate as X, Auth as ee } from "./authentication.js";
import _ from "./config.js";
import { Endorser as L } from "./endorsement.js";
import { GqlClient as te } from "./graphql.js";
import { isSignedContentValid as H } from "./integrity_store.js";
import { L as ae, a as I, S as se } from "./session-DyDHabUm.js";
import { createChunks as ne, createVersionHeader as $, createEncryptedChunk as U, createEncryptedChunks as ie, decryptChunk as re, StorageCipher as oe } from "./storage.js";
const ce = new Error("request for lock canceled");
var de = function(f, e, t, a) {
  function s(n) {
    return n instanceof t ? n : new t(function(i) {
      i(n);
    });
  }
  return new (t || (t = Promise))(function(n, i) {
    function r(h) {
      try {
        o(a.next(h));
      } catch (d) {
        i(d);
      }
    }
    function c(h) {
      try {
        o(a.throw(h));
      } catch (d) {
        i(d);
      }
    }
    function o(h) {
      h.done ? n(h.value) : s(h.value).then(r, c);
    }
    o((a = a.apply(f, e || [])).next());
  });
};
class he {
  constructor(e, t = ce) {
    this._value = e, this._cancelError = t, this._queue = [], this._weightedWaiters = [];
  }
  acquire(e = 1, t = 0) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    return new Promise((a, s) => {
      const n = { resolve: a, reject: s, weight: e, priority: t }, i = P(this._queue, (r) => t <= r.priority);
      i === -1 && e <= this._value ? this._dispatchItem(n) : this._queue.splice(i + 1, 0, n);
    });
  }
  runExclusive(e) {
    return de(this, arguments, void 0, function* (t, a = 1, s = 0) {
      const [n, i] = yield this.acquire(a, s);
      try {
        return yield t(n);
      } finally {
        i();
      }
    });
  }
  waitForUnlock(e = 1, t = 0) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    return this._couldLockImmediately(e, t) ? Promise.resolve() : new Promise((a) => {
      this._weightedWaiters[e - 1] || (this._weightedWaiters[e - 1] = []), pe(this._weightedWaiters[e - 1], { resolve: a, priority: t });
    });
  }
  isLocked() {
    return this._value <= 0;
  }
  getValue() {
    return this._value;
  }
  setValue(e) {
    this._value = e, this._dispatchQueue();
  }
  release(e = 1) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    this._value += e, this._dispatchQueue();
  }
  cancel() {
    this._queue.forEach((e) => e.reject(this._cancelError)), this._queue = [];
  }
  _dispatchQueue() {
    for (this._drainUnlockWaiters(); this._queue.length > 0 && this._queue[0].weight <= this._value; )
      this._dispatchItem(this._queue.shift()), this._drainUnlockWaiters();
  }
  _dispatchItem(e) {
    const t = this._value;
    this._value -= e.weight, e.resolve([t, this._newReleaser(e.weight)]);
  }
  _newReleaser(e) {
    let t = !1;
    return () => {
      t || (t = !0, this.release(e));
    };
  }
  _drainUnlockWaiters() {
    if (this._queue.length === 0)
      for (let e = this._value; e > 0; e--) {
        const t = this._weightedWaiters[e - 1];
        t && (t.forEach((a) => a.resolve()), this._weightedWaiters[e - 1] = []);
      }
    else {
      const e = this._queue[0].priority;
      for (let t = this._value; t > 0; t--) {
        const a = this._weightedWaiters[t - 1];
        if (!a)
          continue;
        const s = a.findIndex((n) => n.priority <= e);
        (s === -1 ? a : a.splice(0, s)).forEach((n) => n.resolve());
      }
    }
  }
  _couldLockImmediately(e, t) {
    return (this._queue.length === 0 || this._queue[0].priority < t) && e <= this._value;
  }
}
function pe(f, e) {
  const t = P(f, (a) => e.priority <= a.priority);
  f.splice(t + 1, 0, e);
}
function P(f, e) {
  for (let t = f.length - 1; t >= 0; t--)
    if (e(f[t]))
      return t;
  return -1;
}
var le = function(f, e, t, a) {
  function s(n) {
    return n instanceof t ? n : new t(function(i) {
      i(n);
    });
  }
  return new (t || (t = Promise))(function(n, i) {
    function r(h) {
      try {
        o(a.next(h));
      } catch (d) {
        i(d);
      }
    }
    function c(h) {
      try {
        o(a.throw(h));
      } catch (d) {
        i(d);
      }
    }
    function o(h) {
      h.done ? n(h.value) : s(h.value).then(r, c);
    }
    o((a = a.apply(f, e || [])).next());
  });
};
class x {
  constructor(e) {
    this._semaphore = new he(1, e);
  }
  acquire() {
    return le(this, arguments, void 0, function* (e = 0) {
      const [, t] = yield this._semaphore.acquire(1, e);
      return t;
    });
  }
  runExclusive(e, t = 0) {
    return this._semaphore.runExclusive(() => e(), 1, t);
  }
  isLocked() {
    return this._semaphore.isLocked();
  }
  waitForUnlock(e = 0) {
    return this._semaphore.waitForUnlock(1, e);
  }
  release() {
    this._semaphore.isLocked() && this._semaphore.release();
  }
  cancel() {
    return this._semaphore.cancel();
  }
}
class R {
  constructor(e, t) {
    this.channel = e, this.channelCreator = t;
  }
  getUserAuth(e) {
    return this.channel.getUserAuth(e);
  }
  sendRequest(e, t, a) {
    return this.retryRequest(
      this.channel.sendRequest,
      e,
      t,
      a
    );
  }
  sendRequestRaw(e, t) {
    return this.retryRequest(
      this.channel.sendRequestRaw,
      e,
      t
    );
  }
  sendCompilableRequest(e, t, a, s) {
    return this.retryRequest(
      this.channel.sendCompilableRequest,
      e,
      t,
      a,
      s
    );
  }
  sendRequestV2(e) {
    return this.retryRequest(this.channel.sendRequestV2, e);
  }
  static async create(e) {
    return new R(await e(), e);
  }
  async retryErrorHandler(e, t) {
    if (console.warn(
      `Failed to send enclave message, re-attempt ${e}: ${t}`
    ), t instanceof M) {
      if (t.originalErrors[0] === "enclave unavailable")
        await this.recreateConnection();
      else if (t.originalErrors[0] === "manual deletion")
        throw new Error(
          "Your session with the enclave has expired. Please report this issue to the Decentriq support team."
        );
    }
    if (t instanceof V)
      throw new Error(`Enclave error: ${t.message}`);
    return t;
  }
  async retryRequest(e, ...t) {
    let a = null;
    for await (const s of z({
      backoffFactor: _.requestRetryBackoffFactor,
      total: _.requestRetryTotal
    }))
      try {
        return await e.call(this.channel, ...t);
      } catch (n) {
        a = await this.retryErrorHandler(s, n) ?? null;
      }
    throw a;
  }
  async recreateConnection() {
    console.warn("[session retry] recreating channel"), this.channel = await this.channelCreator(), console.warn(
      `[session retry] new channel created ${this.channel.stringRepresentation()}`
    );
  }
  stringRepresentation() {
    return `Connection(channel: ${this.channel.stringRepresentation()})`;
  }
}
class T {
  /** Identity of the user interacting with the client. */
  userEmail;
  api;
  graphql;
  logRequests;
  unsafeDisableKnownRootCaCheck;
  connections;
  connectionsLock;
  cachedDecentriqAuths;
  cachedDecentriqAuthsLock;
  /**
   * Create a new client instance.
   *
   * Rather than creating `Client` instances directly using this constructor,
   * use the function [[`Client.create`]].
   */
  constructor(e, t, a, s, n) {
    this.userEmail = e, this.api = t, this.graphql = a, this.logRequests = s, this.unsafeDisableKnownRootCaCheck = n, this.connections = /* @__PURE__ */ new Map(), this.connectionsLock = new x(), this.cachedDecentriqAuths = /* @__PURE__ */ new Map(), this.cachedDecentriqAuthsLock = new x();
  }
  /**
   * The primary way to create a `Client` object.
   *
   * @param userEmail The email address of the user that generated the given Api token.
   * @param apiToken An Api token with which to authenticate oneself.
   *   The Api token can be obtained in the user
   *   account settings in the Decentriq UI.
   */
  static create(e, t, {
    host: a = _.host,
    port: s = _.port,
    useTls: n = _.useTls,
    logRequests: i = _.clientLogRequests,
    unsafeDisableKnownRootCaCheck: r = _.unsafeDisableKnownRootCaCheck
  } = {}) {
    const c = new W(t, a, s, n), o = new te(c, l.GRAPHQL, i);
    return new T(
      e,
      c,
      o,
      i,
      r
    );
  }
  /**
   * Check whether the selected enclaves are deployed at this moment.
   * If one of the enclaves is not deployed, an exception will be raised.
   */
  async checkEnclaveAvailability(e) {
    const a = (await this.getEnclaveSpecifications()).reduce(
      (s, n) => s.add(E(n.proto)),
      /* @__PURE__ */ new Set()
    );
    e.forEach((s, n) => {
      const i = E(s.proto);
      if (!a.has(i))
        throw new Error(
          `No available enclave deployed for attestation spec '${n}' (version ${s.version})`
        );
    });
  }
  /**
   * Get the currently deployed enclave specifications.
   * This method should not be used directly! Enclave specifications should be selected
   * via the `enclaveSpecifications` catalogue exported from the main SDK package.
   */
  async getEnclaveSpecifications() {
    let e;
    const t = u(`
      query GetAttestationSpecsV2 {
        attestationSpecsV2 {
          name
          version
          spec
        }
      }
    `);
    return e = (await this.graphql.post({ query: t })).attestationSpecsV2, e.map((s) => {
      const n = B.AttestationSpecification.decodeDelimited(
        w.util.binary.base64.decode(s.spec)
      );
      return {
        name: s.name,
        proto: n,
        version: s.version,
        workerProtocols: [ae]
      };
    });
  }
  extractDriverSpec(e) {
    const t = e.get("decentriq.driver");
    if (t === void 0)
      throw new Error(
        "Unable to find a specification for the driver enclave named 'decentriq.driver', you can get these specifications from the main package."
      );
    t.clientProtocols === void 0 && (console.warn(
      `Missing client supported protocol versions in driver spec, assuming the latest version: ${I}`
    ), t.clientProtocols = [I]);
    const a = t.clientProtocols, s = t.proto, n = E(
      s
    );
    return [
      s,
      n,
      a
    ];
  }
  async createConnection(e, t) {
    return await this.connectionsLock.runExclusive(async () => {
      let s = this.connections.get(t);
      return s === void 0 && (s = await R.create(
        () => G.create({
          api: this.api,
          attestationSpecificationHash: t,
          driverAttestationSpecification: e,
          graphql: this.graphql,
          logRequests: this.logRequests,
          unsafeDisableKnownRootCaCheck: this.unsafeDisableKnownRootCaCheck
        })
      ), this.connections.set(t, s)), s;
    });
  }
  /**
   * Creates a new [[`Session`]] instance to communicate with a driver enclave.
   * The passed set of enclave specifications must include a specification for
   * a driver enclave.
   *
   * Messages sent through this session will be authenticated
   * with the given authentication object.
   */
  async createSession(e, t) {
    const [
      a,
      s,
      n
    ] = this.extractDriverSpec(t), i = await this.createConnection(
      a,
      s
    );
    return await se.create({
      auth: e,
      client: this,
      clientProtocols: n,
      connection: i,
      driverAttestationSpecificationHash: s
    });
  }
  /**
   * Creates a new [[`SessionV2`]] instance to communicate with a driver enclave.
   * The passed set of enclave specifications must include a specification for
   * a driver enclave.
   *
   * Messages sent through this session will be authenticated
   * with the given authentication object.
   */
  async createSessionV2(e) {
    const t = E(e), a = await this.createConnection(
      e,
      t
    );
    return await K.create({
      client: this,
      connection: a
    });
  }
  /**
   * Creates a [[`Auth`]] object which can be attached to a [[`Session`]].
   * Sessions created using such an [[`Auth`]] object will commonly be used with
   * data rooms that have been configured to use the [[`decentriqPkiAuthentication`]].
   * authentication method.
   */
  async createAuthUsingDecentriqPki(e) {
    const [
      t,
      a,
      s
    ] = this.extractDriverSpec(e), n = await this.createConnection(
      t,
      a
    ), i = await this.createAuth(), c = await new L(i, this, s, n).decentriqPkiEndorsement();
    return i.attachEndorsement({ decentriqPki: c }), i;
  }
  async createEndorser(e, t) {
    const [
      a,
      s,
      n
    ] = this.extractDriverSpec(t), i = await this.createConnection(
      a,
      s
    );
    return new L(e, this, n, i);
  }
  /**
   * Creates a [[`Auth`]] object which can be attached to a [[`Session`]].
   */
  async createAuth() {
    const e = await Z(), t = X(this.userEmail, e), a = new TextEncoder().encode(t);
    return new ee(a, e, this.userEmail);
  }
  async ensureDatasetScope(e) {
    const t = u(`
      mutation GetOrCreateDatasetScope($input: CreateDatasetScopeInput!) {
        scope {
          getOrCreateDatasetScope(input: $input) {
            record {
              id
            }
          }
        }
      }
    `);
    return (await this.graphql.post({
      query: t,
      variables: {
        input: {
          manifestHash: e
        }
      }
    })).scope.getOrCreateDatasetScope.record.id;
  }
  async ensureDcrDataScope(e) {
    const t = u(`
      mutation GetOrCreateDcrDataScope($input: CreateDcrDataScopeInput!) {
        scope {
          getOrCreateDcrDataScope(input: $input) {
            record {
              id
            }
          }
        }
      }
    `);
    return (await this.graphql.post({
      query: t,
      variables: {
        input: {
          dataRoomHash: e
        }
      }
    })).scope.getOrCreateDcrDataScope.record.id;
  }
  /**
   * Uploads `data` as a file usable by enclaves and returns the corresponding
   * manifest hash.
   *
   * @param data: The data to upload as a buffered stream.
   * @param key: Encryption key used to encrypt the file.
   * @param fileName Name of the file.
   */
  async uploadDataset(e, t, a, {
    chunkSize: s = 8 * 1024 ** 2,
    parallelUploadsCount: n = 4,
    description: i,
    size: r,
    statistics: c,
    isAccessory: o = !1,
    usage: h = "PUBLISHED"
  } = {}) {
    const d = await ne(e, s), p = [], q = [];
    for (const { hash: y, contentSize: v } of d)
      p.push(w.util.binary.hex.encode(y)), q.push(v);
    const m = $(), [g, C] = await U(
      t.material,
      O.randomBytes(16),
      new TextEncoder().encode(JSON.stringify(p)),
      m,
      e.length,
      q
    ), k = await this.createUpload(), A = d.length;
    let S = 0;
    for (; S !== A; ) {
      const y = Math.min(
        n,
        A - S
      ), v = d.slice(
        S,
        S + y
      );
      await Promise.all(
        v.map(async ({ hash: N, contentWithHeaders: j }) => {
          await this.encryptAndUploadChunk(
            N,
            j,
            t.material,
            k
          );
        })
      ), S += y;
    }
    const D = await this.ensureDatasetScope(
      w.util.binary.hex.encode(g)
    );
    return await this.finalizeUpload(
      D,
      k,
      a,
      g,
      C,
      p,
      {
        description: i,
        isAccessory: o,
        size: r,
        statistics: c,
        usage: h
      }
    ), w.util.binary.hex.encode(g);
  }
  /**
   * Create chunks of a given size out of the streamed data, encrypting
   * each chunk and uploading groups of chunks to the backend server.
   *
   * @param data: The data to upload as a stream.
   * @param key: Encryption key used to encrypt the file.
   * @param fileName Name of the file.
   * @returns manifestHash The id of the created dataset.
   */
  async uploadDatasetStreamed(e, t, a, {
    chunkSize: s = 8 * 1024 ** 2,
    parallelUploadsCount: n = 4,
    description: i,
    statistics: r,
    progressFn: c,
    isAccessory: o
  } = {}) {
    const h = await this.createUpload();
    let d = 0;
    const p = [], m = await new Promise((S, D) => {
      e.pipeThrough(
        new TransformStream({
          transform(y, v) {
            d += y.data.length, v.enqueue(y);
          }
        })
      ).pipeThrough(Q(s)).pipeThrough(
        new TransformStream({
          transform(y, v) {
            p.push(y.data.length), v.enqueue(y);
          }
        })
      ).pipeThrough(ie(t.material)).pipeThrough(Y(n)).pipeTo(
        this.createParallelUploadSink(h, S, D, c)
      );
    }), g = $(), [C, k] = await U(
      t.material,
      O.randomBytes(16),
      new TextEncoder().encode(JSON.stringify(m)),
      g,
      d,
      p
    ), A = await this.ensureDatasetScope(
      w.util.binary.hex.encode(C)
    );
    return await this.finalizeUpload(
      A,
      h,
      a,
      C,
      k,
      m,
      {
        description: i,
        isAccessory: o,
        size: d,
        statistics: r
      }
    ), w.util.binary.hex.encode(C);
  }
  // Takes a Response with arbitrary chunked transfer stream chunks and turns it into an
  // 8MB encrypted "platform" chunk stream, handling errors in the meantime. Each element
  // in the output is guaranteed to be a standalone encrypted chunk.
  streamResponseEncryptedChunks(e) {
    if (!e.body)
      throw new Error("Response body cannot be streamed");
    const t = e.body.getReader();
    let a = -1, s = !0;
    const n = new Uint8Array(8 * 1024 * 1024 + 4096), i = [];
    let r = 0;
    return new ReadableStream(
      {
        async pull(c) {
          let o;
          const h = async () => {
            if (i.length === 0) {
              const { value: d, done: p } = await t.read();
              if (p) {
                if (r > 0)
                  throw new Error("Trailing data during download");
                c.close();
                return;
              }
              o = d;
            } else
              o = i.pop();
            if (r + o.length <= n.length)
              n.set(o, r), r += o.length;
            else {
              const d = n.length - r;
              n.set(o.subarray(0, d), r), i.push(o.subarray(d)), r = n.length;
            }
          };
          for (; ; )
            if (s) {
              let d = !1, p = 0;
              for (; !d; )
                for (await h(); p < r; p += 1)
                  if (n[p] === 10) {
                    d = !0;
                    break;
                  }
              const q = n.subarray(0, p), m = JSON.parse(new TextDecoder().decode(q));
              if (a = m.V0?.Next?.size, a === void 0) {
                const g = m.V0?.Failure;
                throw g === void 0 ? new Error(
                  "Error during stream decoding: malformed header"
                ) : new Error(
                  `Error during stream decoding: ${g.error}`
                );
              }
              if (a > n.length)
                throw new Error(`Chunk size ${a} too large`);
              r > p + 1 && i.push(
                n.subarray(p + 1, r)
              ), r = 0, s = !1;
            } else {
              for (; r < a; )
                await h();
              const d = n.subarray(0, a);
              r > a && i.push(n.subarray(a, r)), r = 0, s = !0, a = -1, c.enqueue(d);
              return;
            }
        }
      },
      // WARNING: this *must* be set to 0, otherwise the stream will be pulled greedily, causing the reusable buffer to be overwritten!
      { highWaterMark: 0 }
    );
  }
  streamResponseDecrypted(e, t, a) {
    const s = this.streamResponseEncryptedChunks(e).getReader();
    let n = 0;
    return new ReadableStream({
      async pull(i) {
        const { value: r, done: c } = await s.read();
        if (c) {
          i.close();
          return;
        }
        const o = await re(
          t,
          a[n],
          r
        );
        n += 1, i.enqueue(o);
      }
    });
  }
  async readStream(e) {
    const t = [];
    let a = 0;
    const s = e.getReader();
    for (; ; ) {
      const { value: r, done: c } = await s.read();
      if (c)
        break;
      t.push(r), a += r.length;
    }
    if (t.length === 1)
      return t[0];
    const n = new Uint8Array(a);
    let i = 0;
    for (const r of t)
      n.set(r, i), i += r.length;
    return n;
  }
  async downloadDataset(e, t) {
    const a = l.DATASET_CHUNKS_STREAM.replace(
      ":manifest_hash",
      e
    ), s = { "Content-Type": "application/octet-stream" }, n = await this.api.post({
      endpoint: a,
      headers: s,
      reqBody: e
    }), i = await this.streamResponseDecrypted(
      n,
      t,
      [e]
    ), r = JSON.parse(
      new TextDecoder().decode(await this.readStream(i))
    ), c = await this.api.post({
      endpoint: a,
      headers: s,
      reqBody: r.join(`
`)
    });
    return await this.streamResponseDecrypted(
      c,
      t,
      r
    );
  }
  async downloadJobResult(e, t, a, s) {
    const n = l.JOB_RESULT_CHUNKS_STREAM.replace(
      ":job_id",
      e
    ).replace(":task_result_hash", a), i = { "Content-Type": "application/octet-stream" }, r = await this.api.post({
      endpoint: n,
      headers: i,
      reqBody: t
    }), c = await this.streamResponseDecrypted(
      r,
      s,
      [t]
    ), o = JSON.parse(
      new TextDecoder().decode(await this.readStream(c))
    ), h = await this.api.post({
      endpoint: n,
      headers: i,
      reqBody: o.join(`
`)
    });
    return await this.streamResponseDecrypted(
      h,
      s,
      o
    );
  }
  async encryptAndUploadChunk(e, t, a, s) {
    const i = new oe(a).encrypt(t);
    await this.uploadChunk(e, i, s);
  }
  createParallelUploadSink(e, t, a, s) {
    const n = this, i = [];
    return new WritableStream({
      async abort(r) {
        a(r);
      },
      async close() {
        t(i);
      },
      async write(r) {
        const c = await Promise.all(
          r.map(async ({ data: o, progress: h }) => {
            const { chunkHash: d, encryptedChunk: p } = o;
            if (d && p)
              return await n.uploadChunk(d, p, e), {
                chunkHash: w.util.binary.hex.encode(o.chunkHash),
                progress: h
              };
            throw new Error("Chunks must have a hash and data payload");
          })
        );
        if (i.push(...c.map((o) => o.chunkHash)), s !== void 0) {
          const o = c[c.length - 1].progress;
          s(o);
        }
      }
    });
  }
  async uploadChunk(e, t, a) {
    const s = w.util.binary.hex.encode(e), n = l.USER_UPLOAD_CHUNKS.replace(
      ":uploadId",
      a
    ).replace(":chunkHash", s);
    await this.api.put({
      endpoint: n,
      headers: {
        "Content-Type": "application/octet-stream"
      },
      options: { retry: !0 },
      reqBody: t
    });
  }
  async createUpload() {
    const e = u(`
      mutation CreateUpload {
        upload {
          create {
            record {
              id
            }
          }
        }
      }
    `);
    return (await this.graphql.post({ query: e })).upload.create.record.id;
  }
  async finalizeUpload(e, t, a, s, n, i, {
    description: r,
    size: c,
    statistics: o,
    isAccessory: h,
    usage: d
  } = {}) {
    const p = u(`
      mutation FinalizeUpload($input: CreateDatasetForUploadInput!) {
        upload {
          finalizeUploadAndCreateDataset(input: $input) {
            record {
              id
              manifestHash
            }
          }
        }
      }
    `);
    return (await this.graphql.post({
      options: { retry: !0 },
      query: p,
      variables: {
        input: {
          chunkHashes: i,
          description: r,
          isAccessory: h,
          manifest: w.util.binary.base64.encode(n),
          manifestHash: w.util.binary.hex.encode(s),
          name: a,
          scopeId: e,
          size: c,
          statistics: o,
          uploadId: t,
          usage: d
        }
      }
    })).upload.finalizeUploadAndCreateDataset.record.manifestHash;
  }
  /**
   * Returns information about a user dataset.
   */
  async getDataset(e) {
    const t = u(`
      query GetDataset($manifestHash: HexString!) {
        datasetByManifestHash(manifestHash: $manifestHash) {
          id
          name
          manifestHash
          statistics
          size
          description
          createdAt
          usage
          datasetImport {
            dataRoomId
          }
          encryptionKeySecretId
          metadataSecretId
        }
      }
    `);
    return (await this.graphql.post({
      query: t,
      variables: {
        manifestHash: e
      }
    })).datasetByManifestHash;
  }
  /**
   * Returns the a list of datasets that the current user uploaded,
   * regardless of whether they have already been connected to a
   * data room or not.
   */
  async getAvailableDatasets() {
    const e = u(`
      query GetAvailableDatasets {
        myself {
          datasets {
            nodes {
              id
              name
              manifestHash
              statistics
              size
              description
              createdAt
              usage
              encryptionKeySecretId
              metadataSecretId
            }
          }
        }
      }
    `);
    return (await this.graphql.post({ query: e })).myself.datasets.nodes;
  }
  /**
   * Deletes the dataset with the given id from the Decentriq platform.
   */
  async deleteDataset(e) {
    const t = u(`
      mutation DeleteDataset($manifestHash: HexString!) {
        dataset {
          deleteByManifestHash(manifestHash: $manifestHash)
        }
      }
    `);
    await this.graphql.post({
      query: t,
      variables: {
        manifestHash: e
      }
    });
  }
  /**
   * Internal method for programmatically creating Api tokens.
   */
  async generateApiToken(e) {
    const t = u(`
      mutation CreateApiToken($input: CreateApiTokenInput!) {
        apiToken {
          create(input: $input) {
            id
            token
            name
            description
            revoked
            createdAt
          }
        }
      }
    `);
    return (await this.graphql.post({
      query: t,
      variables: {
        input: {
          name: e
        }
      }
    })).apiToken.create;
  }
  /**
   * Internal method for fetching API tokens of a user.
   */
  async getAllApiTokens() {
    return (await this.graphql.post({
      query: u(`
        query getAllApiTokens {
          myself {
            apiTokens {
              nodes {
                id
                token
                name
                description
                revoked
                createdAt
              }
            }
          }
        }
      `)
    })).myself.apiTokens.nodes;
  }
  // TODO:
  /**
   * Internal method for revoking API tokens belonging to a user.
   */
  async revokeApiToken(e) {
    return (await this.graphql.post({
      query: u(`
        mutation RevokeApiToken($id: String!) {
          apiToken {
            revoke(id: $id) {
              id
            }
          }
        }
      `),
      variables: {
        id: e
      }
    })).apiToken.revoke.id;
  }
  async getUserId() {
    return (await this.graphql.post({
      query: u(`
        query GetUserId {
          myself {
            id
          }
        }
      `)
    })).myself.id;
  }
  /**
   * Returns the root certificate used by the Decentriq identity provider.
   * Note that when using this certificate in any authentication scheme, you trust
   * Decentriq as an identity provider!
   */
  async decentriqCaRootCertificate() {
    const e = await this.graphql.post({
      query: u(`
        query getCertificateAuthority {
          certificateAuthority {
            rootCertificate
          }
        }
      `)
    });
    return new TextEncoder().encode(
      e.certificateAuthority.rootCertificate
    );
  }
  /**
     * The authentication method that uses the Decentriq root certificate to authenticate
     * users.
  
     * This method should be specified when building a data room in case you want to interact
     * with that data room either via the web interface or with sessions created using
     * [[`createAuthUsingDecentriqPki`]].
     * Note that when using this authentication method you trust Decentriq as an identity provider!
  
     * You can also create an [[`AuthenticationMethod`]] object directly and supply your own root
     * certificate, with which to authenticate users connecting to your data room.
     * In this case you will also need to issue corresponding user certificates and create your
     * own custom [[`Auth`]] objects.
     */
  async decentriqPkiAuthentication() {
    const e = await this.decentriqCaRootCertificate();
    return J.AuthenticationMethod.create({
      dqPki: {
        rootCertificatePem: e
      }
    });
  }
  async getDataRoomDescription(e, t) {
    const a = t.get("decentriq.driver");
    if (a === void 0)
      throw new Error(
        "Unable to find a specification for the driver enclave named 'decentriq.driver', you can get these specifications from the main package."
      );
    const s = E(
      a.proto
    );
    return await this.getDataRoomByHash(e, s);
  }
  async getDataRoomByHash(e, t) {
    const s = (await this.graphql.post({
      query: u(`
        query GetPublishedDataRoom($dataRoomHash: String!) {
          publishedDataRoom(id: $dataRoomHash) {
            id
            title
            driverAttestationHash
            isStopped
            createdAt
            updatedAt
          }
        }
      `),
      variables: {
        dataRoomHash: e
      }
    })).publishedDataRoom;
    if (s) {
      if (s.driverAttestationHash !== t)
        throw new Error(
          `Driver attestation hash for requested dcr doesn't match '${s.driverAttestationHash}' != '${t}'`
        );
      return s;
    }
  }
  async getUserCertificate(e, t) {
    return (await this.graphql.post({
      query: u(`
        query getUserCertificate($input: UserCsrInput!) {
          certificateAuthority {
            userCertificate(input: $input)
          }
        }
      `),
      variables: {
        input: {
          csrPem: t,
          email: e
        }
      }
    })).certificateAuthority.userCertificate;
  }
  async getScope(e) {
    return (await this.graphql.post({
      query: u(`
        query GetScope($scopeId: String!) {
          scope(id: $scopeId) {
            id
            organization {
              id
              name
            }
            owner {
              id
              email
            }
            scopeType
            manifestHash
            dataRoomHash
            # driverAttestationHash
            createdAt
          }
        }
      `),
      variables: {
        scopeId: e
      }
    })).scope;
  }
  /**
   * Data Room API
   */
  async createDataRoom(e, t) {
    let a;
    try {
      a = b.CreateDataRoomSchema.parse(e);
    } catch (i) {
      throw i instanceof F ? new Error(
        `Invalid schema for createDataRoom definition: ${i.message}`
      ) : i;
    }
    const s = {
      payload: JSON.stringify(a)
    }, n = await this.api.post({
      endpoint: l.DATA_ROOMS_COLLECTION,
      headers: { "Content-Type": "application/json" },
      reqBody: JSON.stringify(s)
    });
    if (n.status == 201) {
      const i = n.headers.get("Location");
      if (i) {
        const r = i.split("/").pop();
        if (r)
          return this.getDataRoom(r, t);
        throw Error(
          "Failed to create data room: malformed Location header in response"
        );
      } else
        throw Error(
          "Failed to create data room: missing Location header in response"
        );
    }
    throw Error(
      `Failed to create data room: received ${n.status} ${await n.text()}`
    );
  }
  async getDataRooms(e) {
    const t = await this.getUserId(), a = l.USER_DATA_ROOMS_COLLECTION.replace(
      ":user_id",
      t
    ), s = await this.api.get({ endpoint: a });
    if (s.status === 200)
      return (await s.json()).data.map((c) => this.verifyDcr(c, e));
    throw new Error(
      `Failed to get data rooms: received ${s.status} ${await s.text()}`
    );
  }
  verifyDcr(e, t) {
    if (H(
      e.id,
      "dcr_state",
      e.signedContent,
      t
    )) {
      const s = JSON.parse(
        e.signedContent.content
      ), n = b.DataRoomSchema.parse(s);
      return {
        createdAt: e.createdAt,
        id: e.id,
        isStopped: e.isStopped,
        ownerId: e.ownerId,
        state: n,
        updatedAt: e.updatedAt
      };
    } else
      throw new Error(`Unable to verify DCR with id ${e.id}`);
  }
  verifyAuditLog(e, t, a) {
    if (H(
      e,
      "dcr_audit_log",
      t.signed_content,
      a
    ))
      return {
        logs: JSON.parse(
          t.signed_content.content
        ).map(
          (r) => b.AuditLogLineSchema.parse(r)
        )
      };
    throw new Error(
      `Unable to verify DCR audit log for data room ${e}`
    );
  }
  async getDataRoom(e, t) {
    const a = await this.getUnverifiedDataRoom(e);
    return this.verifyDcr(a, t);
  }
  async getUnverifiedDataRoom(e) {
    const t = l.DATA_ROOM.replace(":data_room_id", e);
    return await (await this.api.get({
      endpoint: t
    })).json();
  }
  async getUnverifiedDataRoomAuditLog(e) {
    const t = l.DATA_ROOM_AUDIT_LOG.replace(
      ":data_room_id",
      e
    );
    return await (await this.api.get({
      endpoint: t
    })).json();
  }
  async getDataRoomAuditLog(e, t) {
    const a = await this.getUnverifiedDataRoomAuditLog(e);
    return this.verifyAuditLog(e, a, t);
  }
  async getDataRoomActions(e) {
    const t = l.DATA_ROOM_ACTIONS.replace(
      ":data_room_id",
      e
    );
    return (await this.api.get({
      endpoint: t
    })).json();
  }
  async stopDataRoom(e) {
    const t = l.DATA_ROOM_STOP.replace(
      ":data_room_id",
      e
    ), a = await this.api.post({
      endpoint: t,
      reqBody: JSON.stringify({})
    });
    if (a.status !== 200)
      throw new Error(
        `Failed to stop data room: received ${a.status} ${await a.text()}`
      );
  }
  /**
   * Action API
   */
  async getDataRoomActionInfo(e, t) {
    const a = {
      data_room_id: e,
      payload: JSON.stringify(t)
    };
    return (await this.api.post({
      endpoint: l.ACTIONS_COLLECTION,
      headers: { "Content-Type": "application/json" },
      reqBody: JSON.stringify(a)
    })).json();
  }
  /**
   * Job API
   */
  async createJob(e, t) {
    const a = {
      data_room_id: e,
      payload: JSON.stringify(t)
    }, s = await this.api.post({
      endpoint: l.JOBS_COLLECTION,
      headers: { "Content-Type": "application/json" },
      reqBody: JSON.stringify(a)
    });
    if (s.status === 201) {
      const n = s.headers.get("Location");
      if (n) {
        const i = n.split("/").pop();
        if (i)
          return this.getJob(i);
        throw Error(
          "Failed to create job: malformed Location header in response"
        );
      } else
        throw Error(
          "Failed to create job: missing Location header in response"
        );
    }
    throw Error(
      `Failed to create job: received ${s.status} ${await s.text()}`
    );
  }
  async getJob(e) {
    const t = l.JOB.replace(":job_id", e);
    return (await this.api.get({
      endpoint: t
    })).json();
  }
  async getJobTasks(e) {
    const t = l.JOB_TASKS_COLLECTION.replace(":job_id", e);
    return (await this.api.get({
      endpoint: t
    })).json();
  }
  async getJobStatus(e) {
    const t = l.JOB_STATUS.replace(":job_id", e);
    return (await this.api.get({
      endpoint: t
    })).json();
  }
  async getJobFreshness(e) {
    const t = l.JOB_FRESHNESS.replace(":job_id", e);
    return (await this.api.get({
      endpoint: t
    })).json();
  }
  async checkDataLabCompatibility(e, t) {
    const a = l.CHECK_DATA_LABS_COMPATIBILITY, s = await this.api.post({
      endpoint: a,
      headers: { "Content-Type": "application/json" },
      reqBody: JSON.stringify({
        dataLabIds: t,
        mediaDcrId: e
      })
    });
    if (s.status === 200) {
      const n = await s.json();
      return new Map(Object.entries(n.errorsByDataLab));
    } else
      throw new Error(
        `Failed to check data lab compatibility: ${s.status} ${await s.text()}`
      );
  }
  async getDataRoomPolicies(e, t) {
    const a = l.DATA_ROOM_POLICIES.replace(
      ":data_room_id",
      e
    ), s = await this.api.post({
      endpoint: a,
      headers: { "Content-Type": "application/json" },
      reqBody: JSON.stringify(t)
    });
    if (s.status === 200)
      return await s.json();
    throw new Error(
      `Failed to get policy metadata: ${s.status} ${await s.text()}`
    );
  }
  async getDatasetPublications(e) {
    const t = l.DATASET_PUBLICATIONS, a = await this.api.post({
      endpoint: t,
      headers: { "Content-Type": "application/json" },
      reqBody: JSON.stringify(e)
    });
    if (a.status === 200)
      return await a.json();
    throw new Error(
      `Failed to get dataset publications: ${a.status} ${await a.text()}`
    );
  }
}
const ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Client: T
}, Symbol.toStringTag, { value: "Module" }));
export {
  T as C,
  ke as c
};
//# sourceMappingURL=client-CUQHQEcE.js.map
